import AdminBtn from "./AdminBtn";

export function buildRealEstateAdminNavLinks({
  onOpenSourceQuality,
  onOpenLocationQuality,
  onOpenImageHealth,
  onOpenImageCache,
  onOpenMediaQualityDashboard,
  onOpenCanonicalListings,
  onOpenGeocodeQueue,
  current,
}) {
  const links = [];

  const add = (id, label, onClick) => {
    if (!onClick) {
      return;
    }
    links.push({
      id,
      label,
      onClick,
      isActive: current === id,
    });
  };

  add("listings", "Listings", onOpenCanonicalListings);
  add("geocode", "Geocoding", onOpenGeocodeQueue);
  add("locationQuality", "Location Quality", onOpenLocationQuality);
  add("trust", "Source Trust", onOpenSourceQuality);
  add("imageHealth", "Image Health", onOpenImageHealth);
  add("imageCache", "Image Cache", onOpenImageCache);
  add("media-quality", "Media Quality", onOpenMediaQualityDashboard);

  return links;
}

export default function RealEstateAdminNav({ links, onNavigate }) {
  if (!links?.length) {
    return null;
  }

  return (
    <nav className="admin-console__nav" aria-label="Real estate quality navigation">
      <div className="admin-console__nav-bar">
        {links.map((link) => (
          <AdminBtn
            key={link.id}
            type="button"
            variant="nav"
            className={link.isActive ? "is-active" : ""}
            onClick={() => (link.onClick ? link.onClick() : onNavigate?.(link.id))}
          >
            {link.label}
          </AdminBtn>
        ))}
      </div>
    </nav>
  );
}
